module.exports = __webpack_public_path__ + "img/elevator-offline.bf4b7c04.png";